<template>
  <EditorPageWrapper
    wrapperId="app-guide"
    :iconComponent="AppGuideIcon"
    title="APP GUIDE"
    page="appguide"
    collection="appguide"
  />
</template>

<script>
  import EditorPageWrapper from '@/components/utilities/EditorPageWrapper.vue'
  import AppGuideIcon from '@/assets/icons/AppGuideIcon.vue'

  export default {
    name: 'AppGuide',
    components: {
      EditorPageWrapper,
    },
    setup() {
      return {
        AppGuideIcon,
      }
    },
  }
</script>
